import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SignupService } from '../services/signup.service';
import { CaseManagementService } from '../services/caseManagement.service';
import { CompleteSignUpService } from '../services/complete-sign-up.service';

@Component({
  selector: 'app-email-pin-verification',
  templateUrl: './email-pin-verification.component.html',
  styleUrls: ['./email-pin-verification.component.css']
})
export class EmailPinVerificationComponent implements OnInit {

  userCode: string;
  loading = false;
  linkExpired: boolean;

  constructor(
    private router: Router,
    private signupService: SignupService,
    private route: ActivatedRoute,
    private caseManagementService: CaseManagementService,
    private completeSignUpService: CompleteSignUpService
  ) {
    this.route.params.subscribe(params => {
      this.userCode = params.emailVerificationCode;
    })
    this.completeSignUpService.pageLoader.subscribe((res: boolean) => {
      this.loading = res;
    });
  }

  ngOnInit() {
    this.loading = true;
    this.signupService.verifyEmail(this.userCode).subscribe((response: any) => {
      if (response == null) {
        this.loading = false;
        this.linkExpired = true;
      } else {
        // this.loading = false;
        this.linkExpired = false;
        this.signupService.setCompanyDetails(response);
        this.caseManagementService.setIsFromVerificationLink('verification');
        // this.router.navigate(['/termsAndConditions']);
        this.completeSignUpService.completeSignUp();
      }
    }, (error) => {
      console.error('EmailPinVerificationComponent_ngOnInit', error);
    });
  }

}

